@for (track of tracks; track track; let i = $index) {
    <div
        [ngClass]="{ 'flex-1': i < tracks.length - 1 }"
        class="flex text-center text-xs items-center">
        <div class="px-3 flex justify-center relative">
            <i
                [ngClass]="
                    currentTrack.index === i
                        ? track?.icon
                        : !(currentTrack.index >= i && completedIcon)
                          ? ''
                          : completedIcon
                "
                [style.backgroundColor]="
                    currentTrack.index >= i ? '' : secondaryColour
                "
                [style.color]="primaryColour"
                class="text-base sm:text-xl flex justify-center items-center track-icon"></i>
            <div
                [ngClass]="{
                    'font-bold': i <= currentTrack.index,
                    edge: (i === 0 || i === tracks.length - 1) && wrapLabel,
                }"
                [style.color]="
                    currentTrack.index > i
                        ? completeSectionTextColour
                        : textColour
                "
                class="absolute mt-5 sm:mt-6 label">
                {{ track?.name }}
            </div>
        </div>
        @if (i < tracks.length - 1) {
            <div class="flex items-center flex-1 track-bar">
                <div
                    [style.backgroundColor]="secondaryColour"
                    class="inner-track"></div>
                <div
                    [ngStyle]="{
                        width:
                            i < currentTrack.index
                                ? '100%'
                                : i === currentTrack.index
                                  ? percentage
                                  : '0',
                    }"
                    [style.backgroundColor]="primaryColour"
                    class="track-progress"></div>
            </div>
        }
    </div>
}
